// extracted by mini-css-extract-plugin
export default {"Clover":"Clover-styles__Clover__qmU82","Clover__Animated":"Clover-styles__Clover__Animated__FjkkV","clover":"Clover-styles__clover__yqx_k"};